import { cn } from "@/lib/utils/common";

type InfoFieldProps = {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
};

export function InfoField({ children, className, fullWidth = false }: InfoFieldProps) {
  return (
    <article className={cn("flex flex-col gap-y-1 min-h-16", fullWidth && "col-span-full", className)}>
      {children}
    </article>
  );
}
